import { Settings } from "src/model/class/settings";

/**
 * A service of a building, as offered on the dashboard: used by the side menu to jump straight
 * to it.
 */
export interface BuildingService {
  /** Translation key of its name */
  labelKey: string;
  /** Same icon as its dashboard card (white line drawing, used as a mask in the menu) */
  image: string;
  /** Address of its page (some contain the building area) */
  path: (idAreaLocal: number) => string;
  /** Prefix that recognises its pages in the current address */
  match: RegExp;
  /** Enabled by the server settings */
  isEnabled: (settings: Settings) => boolean;
  /** Can be opened on the demo building (as on the dashboard) */
  allowedInDemo: boolean;
}

/** Services in the same order as the dashboard */
export const BUILDING_SERVICES: Array<BuildingService> = [
  {
    labelKey: "dictionary.myCustomAccesses",
    image: "assets/img/digitalPlace/my-access-white.svg",
    path: (idArea) => `/reserved-area/${idArea}/my-access`,
    match: /^\/reserved-area\/[^/]+\/my-access/,
    isEnabled: (settings) => !!settings?.ShowAccessControl,
    allowedInDemo: false,
  },
  {
    labelKey: "dictionary.supervisions",
    image: "assets/img/digitalPlace/supervision-white.svg",
    path: () => "/reserved-area/supervisions",
    match: /^\/reserved-area\/supervisions/,
    isEnabled: (settings) => !!settings?.ShowSupervision,
    allowedInDemo: true,
  },
  {
    labelKey: "dictionary.consumptionManagementTitle",
    image: "assets/img/digitalPlace/consumption-white.svg",
    path: () => "/reserved-area/consumption-management",
    match: /^\/reserved-area\/consumption-management/,
    isEnabled: (settings) => !!settings?.AccessConsumptionResearch,
    allowedInDemo: true,
  },
  {
    labelKey: "dictionary.alarms",
    image: "assets/img/digitalPlace/alarms-white.svg",
    path: () => "/reserved-area/report/alarms-history",
    match: /^\/reserved-area\/report\/alarms-history/,
    isEnabled: (settings) => !!settings?.ShowReport_Alarms,
    allowedInDemo: false,
  },
  {
    labelKey: "dictionary.condominiumBills",
    image: "assets/img/digitalPlace/bills-white.svg",
    path: () => "/reserved-area/list-bills",
    match: /^\/reserved-area\/list-bills/,
    isEnabled: (settings) => !!settings?.AccessBillManagement,
    allowedInDemo: false,
  },
  {
    labelKey: "dictionary.expenseNote",
    image: "assets/img/digitalPlace/expense-note-white.svg",
    path: () => "/reserved-area/expenses-note",
    match: /^\/reserved-area\/expenses-note/,
    isEnabled: (settings) => !!settings?.AccessExpenseNotes,
    allowedInDemo: false,
  },
  {
    labelKey: "dictionary.quotesManagement",
    image: "assets/img/digitalPlace/quotes-white.svg",
    path: () => "/reserved-area/list-quotes",
    match: /^\/reserved-area\/list-quotes/,
    isEnabled: (settings) => !!settings?.AccessQuoteManagement,
    allowedInDemo: false,
  },
  {
    labelKey: "dictionary.documentSecurity",
    image: "assets/img/digitalPlace/document-security-white.svg",
    path: () => "/reserved-area/document-security",
    match: /^\/reserved-area\/document-security/,
    isEnabled: () => true,
    allowedInDemo: false,
  },
  {
    labelKey: "dictionary.voting",
    image: "assets/img/digitalPlace/voting-white.svg",
    path: () => "/reserved-area/voting",
    match: /^\/reserved-area\/voting/,
    isEnabled: () => true,
    allowedInDemo: false,
  },
  {
    labelKey: "dictionary.weeklyPlanning",
    image: "assets/img/digitalPlace/weekly-planning-calendar-white.svg",
    path: (idArea) => `/reserved-area/weekly-planning/${idArea}`,
    match: /^\/reserved-area\/weekly-planning\//,
    isEnabled: (settings) => !!settings?.ShowWeeklyPlannings,
    allowedInDemo: false,
  },
  {
    labelKey: "dictionary.scenarios",
    image: "assets/img/scenario.svg",
    path: () => "/reserved-area/programming/scenarios",
    match: /^\/reserved-area\/programming\/scenarios/,
    isEnabled: (settings) => !!settings?.ShowSceneAndSchedule,
    allowedInDemo: false,
  },
];
